module.exports = __webpack_public_path__ + "img/image0.3ab78ec0.png";